module.exports = __webpack_public_path__ + "static/hygiene-8f9b62f360a8aed9f216f537f57e9ee2.svg";